import { Injectable } from '@angular/core';
import { CommunicationService } from '../common/services/Communication.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../common/services/authentication.service';

@Injectable({
  providedIn: 'root'
})

export class NavigationClick {
  data: any;

  constructor(
    communicationService: CommunicationService,
    private router: Router,
    private authenticationService: AuthenticationService) {
    this.data = communicationService.data;
  }

  public _theNavigateButtons(id: string, isLogin: boolean) {
    if (id == '19798e88b047b88d12458ec93510d1d0') { // online events no login
      this.router.navigate(['/industries/onlineevents']);
    }
    else if (!isLogin) {
      this.data.industries.forEach((element: { ids: string; routers: string; }) => {
        if (element.ids === id) {
          this.router.navigate([element.routers]);
        }
      });
    } else {
      this.data.industries.forEach((element: { ids: string; routers: string; }) => {
        if (element.ids === id) {
          this.router.navigate(['/industries/' + element.routers]);
        }
      });
    }
  }
}
